// extracted by mini-css-extract-plugin
export default {"block":"ho","sticky":"io","aside":"jo","container":"ko","option":"lo","language":"mo"};